import { GoalType } from 'models/set';

export const getContentTypeDisplayName = (goalType: GoalType): string => {
  switch (goalType) {
    case 'set':
      return 'Learning Set';
    case 'assessment':
      return 'Assessment';
    case 'survey':
      return 'Survey';
    case 'scorm':
      return 'SCORM';
  }
};